<div *ngIf="threads$ | async">
  <app-alert *ngIf="(alert$ | async) as alert"
      [level]="alert.level"
      [message]="alert.message"
      (dismissed)="handleAlertDismissed()"
  ></app-alert>
  <div style="display: flex; padding: 1rem 0;" *ngIf="canRefreshHubspotEmails">
    <div style="margin-left: auto;">
      <button class="refresh-emails-btn" [disabled]="hubspotEmailLoading" mat-raised-button (click)="pullHubspotEmails()">
        <div *ngIf="!hubspotEmailLoading">
          <mat-icon style="vertical-align: middle;">refresh</mat-icon> Marketing Emails
        </div>
        <div *ngIf="hubspotEmailLoading">Refresh Queued</div>
      </button>
    </div>
  </div>
  <div *ngIf="borrower.status !== 'dead' && borrower.status !== 'doNotContact' && !inComplianceReview" class="message-display-container">
    <div *ngIf="!showEditor" (click)="startNewMessage(true)" class="fake-message-container">
      <div class="input-block">
        <textarea name="add-comment" placeholder="Type a new message..."></textarea>
      </div>
      <button data-cy="start-new-message" mat-raised-button (click)="startNewMessage(true)">Send</button>
    </div>
    <app-messages-create
      *ngIf="showEditor"
      [borrower]="borrower"
      [thread]="thread"
      [user]="(lenderUser$ | async)?.fullName"
      (emailCreate)="handleEmailCreate($event)"
      (cancelMessage)="startNewMessage(false)">
    </app-messages-create>
  </div>
  <app-message-thread
    *ngFor="let thread of (threads$ | async); trackBy: trackById; let first = first"
    [first]="first"
    [borrower]="borrower"
    [thread]="thread"
    [user]="(lenderUser$ | async)">
  </app-message-thread>
  <div *ngIf="(threads$ | async).length === 5" class="text-center">
    <div *ngIf="!((loadingAll$ | async) === false && (threads$ | async).length === 5 && (disableLoadAll$ | async))">
      <div class="date-group">
        <div class="my-3 position-relative">
          <hr class="w-100 position-absolute h-50 m-0 message-divider" />
          <div class="text-center">
            <span class="bg-white px-4">
              <button mat-flat-button
                      [disabled]="(disableLoadAll$ | async)"
                      class="newstd-btn newstd-btn-default mat-elevation-z4 mat-focus-indicator mat-flat-button mat-button-base"
                      (click)="loadAllThreads()">
                Load All
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="spinner-container" *ngIf="(loadingAll$ | async) === true">
      <mat-spinner></mat-spinner>
    </div>
  </div>

  <div class="text-center tw-font-bold tw-mt-4" *ngIf="(loadingAll$ | async) === false && (threads$ | async).length >= 5 && (disableLoadAll$ | async)">
    Showing all messages.
  </div>

</div>
